import { fonts } from './fonts.constants';
import { FontOption } from './fonts.types';

type GetAvailableFontsProps = {
  chain?: string | null;
  superAdmin: boolean;
};

export const getAvailableFonts = ({ chain, superAdmin }: GetAvailableFontsProps): Array<FontOption> => {
  if (superAdmin) {
    return fonts;
  }

  return fonts.filter((font) => {
    if (!font.exclusiveToChain) {
      return true;
    }

    return font.exclusiveToChain === chain;
  });
};
